const Graph = require('./BaseGraph')

module.exports = class ShopGraph extends Graph 
{
    constructor(apiDomain, path="shop")
    {
        super(apiDomain, path)
    }

    productQuery(fields, params=null)
    {
        if (params)
            return { type: 'product', query: this.queryString('product', fields, params) }

        return { type: 'product', query: `query getProduct ($code: String!) {
            product(code: $code)
            ${this.queryFields(fields)}
        }` }
    }

    productsQuery(fields, params=null)  
    {
        if (params)
            return { type: 'products', query: this.queryString('products', fields, params) }

        return { type: 'products', query: `query getProducts ($parent: String, $tags: [String], $search: String, $limit: Int, $offset: Int) {
            product(parent: $parent, tags: $tags, search: $search, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }

    priceQuery(fields, params=null)
    {
        if (params)
            return { type: 'price', query: this.queryString('price', fields, params) }

        return { type: 'price', query: `query getPrice ($product: String!, $currency: String, $promo: String) {
            price(product: $product, currency: $currency, promo: $promo)
            ${this.queryFields(fields)}
        }` }
    }

    orderQuery(fields, params = null) {
        if (params)
            return { type: 'order', query: this.queryString('order', fields, params) }

        return {
            type: 'order', query: `query order ($orderId: String!) {
            order(orderId: $orderId)
            ${this.queryFields(fields)}
        }` }
    }

    onetimeOrderQuery(fields, params=null)
    {
        if (params)
            return { type: 'oneTimeOrder', query: this.queryString('oneTimeOrder', fields, params) }

        return { type: 'oneTimeOrder', query: `query oneTimeOrder ($product: String!, $userId: String!) {
            oneTimeOrder(product: $product, userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    subscriptionQuery(fields, params=null)
    {
        if (params)
            return { type: 'subscription', query: this.queryString('subscription', fields, params) }

        return { type: 'subscription', query: `query getSubscription ($product: String!, $userId: String!) {
            subscription(product: $product, userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    cartQuery(fields, params=null)
    {
        if (params)
            return { type: 'cart', query: this.queryString('cart', fields, params) }

        return { type: 'cart', query: `query getCart ($cart: String!, $userId: String) {
            cart(cart: $cart, userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    checkoutMutation(fields, params=null)
    {
        if (params)
            return { type: 'checkout', query: `mutation {
                checkout(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'checkout', query: `mutation checkout ($cart: String!, $userId: String!, $payment_method: String!, $billing: String, $credit_card: String) {
            checkout(cart: $cart, userId: $userId, payment_method: $payment_method, billing: $billing, credit_card: $credit_card)
            ${this.queryFields(fields)}
        }` }
    }

    changeMutation(fields, params=null)
    {
        if (params)
            return { type: 'change', query: `mutation {
                change(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'change', query: `mutation change ($item_id: ID!, $product: String!, $riders: [String]) {
            change(item_id: $item_id, product: $product, riders: $riders)
            ${this.queryFields(fields)}
        }` }
    }
}